import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CategoriaService } from "../../containers/bandeja-principal/administrador/configuracion/categoria/categoria.service";
import { SubcategoriaService } from "../../containers/bandeja-principal/administrador/configuracion/subcategoria/subcategoria.service";

interface CategoriaData {
  categoria_id: number;
  descripcion: string;
}

interface SubcategoriaData {
  sub_categoria_id: number;
  descripcion: string;
}

@Component({
  selector: "app-modal-nueva-categoria",
  templateUrl: "./modal-nueva-categoria.component.html",
  styleUrls: ["./modal-nueva-categoria.component.scss"],
})
export class ModalNuevaCategoriaComponent implements OnInit {
  @Input() mensaje: string;
  @Input() titulo: string;
  @Input() categoriaData: any;
  @Input() esObligatorio: any;
  aceptaElegirCategoria: boolean = false;
  nuevasCategorias: CategoriaData[] = [];
  subcategorias: SubcategoriaData[] = [];
  nuevaCategoria: any = null;
  subcategoria: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private categoriaService: CategoriaService,
    private subcategoriaService: SubcategoriaService
  ) {}

  ngOnInit(): void {}

  confirm() {
    if (this.activeModal) {
      this.aceptaElegirCategoria = true;
      if (this.aceptaElegirCategoria) {
        this.categoriaService
          .getNuevasCategoriasByCategoriaId(this.categoriaData)
          .subscribe((x: any) => {
            this.nuevasCategorias = x.data as CategoriaData[];
          });
      }
    }
  }

  confirmConDatos(): any {
    if (this.nuevaCategoria && this.subcategoria) {

      interface datos {
        nueva_categoria_id: number,
        subcategoria_id: number,
        desc_nueva_categoria: string,
        desc_subcategoria: string,
      }

      const result: datos = {
        nueva_categoria_id: this.nuevaCategoria.categoria_id,
        subcategoria_id: this.subcategoria.sub_categoria_id,
        desc_nueva_categoria: this.nuevaCategoria.descripcion,
        desc_subcategoria: this.subcategoria.descripcion
      }
      
      this.activeModal.close(result);
    }
  }

  onChangeCategoria(): any {
    this.subcategoriaService
      .getByCategoria(this.nuevaCategoria.categoria_id)
      .subscribe((x: any) => {
        this.subcategorias = x.data as SubcategoriaData[];
      });
  }

  cancel() {
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}
